module.exports = __webpack_public_path__ + "static/img/logo77.bd8f444.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo77.png
// module id = QN2f
// module chunks = 1